import i18n from "@/i18n";

const LICENSE_ERROR_PATTERNS = [
  // 429 - Quota Exceeded (with parameter extraction)
  // suppressToast: true - Error is displayed in deepfake list instead
  {
    status: 429,
    messageMatch: /quota.*exceeded/i,
    titleKey: "feedback.error.license.generic.title",
    descriptionKey: "feedback.error.license.quotaExceeded",
    suppressToast: true,
    extractParams: (errorMessage) => {
      const match = errorMessage.match(/(\d+)\s*\/\s*(\d+)/);
      if (match) {
        return {
          used: match[1],
          limit: match[2],
        };
      }
      return {};
    },
  },

  // 403 - License Expired (specific message)
  {
    status: 403,
    messageMatch: /business license.*expired|license.*expired|expired.*license/i,
    titleKey: "feedback.error.license.generic.title",
    descriptionKey: "feedback.error.license.subscriptionExpired",
  },

  // All other 403/404 errors (generic message)
  {
    status: 403,
    titleKey: "feedback.error.license.generic.title",
    descriptionKey: "feedback.error.license.generic.description",
  },
  {
    status: 404,
    titleKey: "feedback.error.license.generic.title",
    descriptionKey: "feedback.error.license.generic.description",
  },
];

/**
 * Extracts error message from axios error response
 * @param {Object} error - Axios error object
 * @returns {string} - Error message text
 */
const getErrorMessage = (error) => {
  return error?.response?.data?.detail || error?.response?.data?.message || error?.response?.data?.error || "";
};

/**
 * Maps license API error to user-friendly translated message
 * @param {Object} error - Axios error object from /licence endpoint
 * @returns {Object} - Object with translated title and description
 */
export const mapLicenseError = (error) => {
  const status = error?.response?.status;
  const errorMessage = getErrorMessage(error);

  // Find matching pattern
  const pattern = LICENSE_ERROR_PATTERNS.find((p) => {
    if (p.status !== status) return false;
    if (!p.messageMatch) return true; // Generic fallback
    return p.messageMatch.test(errorMessage);
  });

  // Get translation
  const t = i18n?.global?.t || i18n?.t;
  const titleKey = pattern?.titleKey || "feedback.error.license.generic.title";
  const descriptionKey = pattern?.descriptionKey || "feedback.error.license.generic.description";

  // Extract parameters if pattern has extractParams function
  const params = pattern?.extractParams ? pattern.extractParams(errorMessage) : {};

  return {
    title: t(titleKey),
    description: t(descriptionKey, params),
    suppressToast: pattern?.suppressToast || false,
  };
};
